export enum VtFilterMenuItemType {
  Add = 'add',
  Delete = 'delete',
  Update = 'update',
  Copy = 'copy',
  Other = 'other',
  Edit = 'edit',
}
